<template>
    <div class="sustainable-component competence-admin-competence-category">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-admin-competence-category</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-10">
                    {{categoryname}}
                </div>
                <div class="col-2">
                    <div class="dropdown text-right pr-2" v-if="disabled == false">
                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                            ...
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="javascript:void(0)" class="dropdown-item" @click="updateCategory">Ändra</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col-8 pr-0">
                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Ange" v-model="competencename" variant="outlined" density="compact" hide-details></v-text-field>
                            </div>
                            <div class="col-4 p-0 pl-1">
                                <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addCompetence">
                                    Spara ny
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col">
                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2" style="font-weight:normal">Utbildning</th>
                                <th class="col-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in competencelist" :key="index">
                                <td class="col-2">
                                    <span>{{item.Name}}</span>
                                </td>

                                <td class="col-2">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateCompetenceItem(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="removeCompetence(item.CompetenceId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <UpdateCompetenceCategory2 v-bind:disabled="disabled" ref="updateCompetenceCategoryModal" @updated="updated"></UpdateCompetenceCategory2>
        <UpdateCompetence v-bind:disabled="disabled" ref="updateCompetenceModal" @updated="updated"></UpdateCompetence>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import CompetenceService from "../../Services/CompetenceService";
    import UpdateCompetenceCategory2 from './update/competence-update-competence-category2.vue'
    import UpdateCompetence from './update/competence-update-competence.vue'
    import CommonSpinner from '../../common/common-spinner.vue'

    import { ref } from 'vue'

    const updateCompetenceCategoryModal = ref(null);
    const updateCompetenceModal = ref(null);


    export default {

        name: 'competence-admin-competence-category',
        emits: ['updated'],
        props: {
            model: Object,
            competencecategoryid: Number,
            categoryname: String,
            competencelist: Array,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            UpdateCompetenceCategory2,
            UpdateCompetence,
            CommonSpinner
        },
        methods: {
            updated(){
                this.$emit('updated')
            },
            async addCompetence() {
                if (this.competencename == null || this.competencename == "") {
                    alert("Ange ett namn på kompetensen");
                    return;
                }
                this.loading++;
                try {
                    await CompetenceService.addCompetence(this.competencecategoryid, this.competencename);
                    this.displaySnackBar("Kompetensen lades till");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.$emit('updated')
                this.loading--;
            },
            async removeCompetence(id) {
                if (confirm(" Är du säker att du vill radera kompetensen?")) {
                    this.loading++;
                    try {
                        await CompetenceService.deleteCompetence(id);
                        this.displaySnackBar("Kompetensen togs bort");
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.$emit('updated')
                    this.loading--;
                }
            },
            updateCompetenceItem(item) {
                this.loading++;
                this.updateCompetenceModal.open(item);
                this.loading--;
            },
            updateCategory() {
                this.loading++;
                try {
                    this.updateCompetenceCategoryModal.open(this.competencecategoryid, this.categoryname);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },

        },

        data() {
            return {
                competencename:null,
                rules: ValidationService.rules(),
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            

        },
        mounted() {
            this.internalModel = this.model;
        },
        setup() {
            return { updateCompetenceCategoryModal, updateCompetenceModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
